import zh from "./zh.json"; // for now use the same file for cn and english to make the development easier, will be change to message-zh later in production
import en from "./en.json"; 

/**
 * Translate the extracted i18n file into the correct format
 *  old format
 * {
 *    "header.signIn": {
 *       "defaultMessage": "Sign in"
 *    }
 *  }
 * new format
 * {
 *     "header.signIn": "Sign in"
 * }
 */
const translate = (oldObject) => {
  const keys = Object.keys(oldObject);
  const newObject = {};
  for (let key of keys) {
    newObject[key] = oldObject[key]["defaultMessage"];
  }
  return newObject;
}

const localeMessages = {
  "en-US": translate(en),
  "zh-CN": translate(zh)
};

export default localeMessages;



